import { SVGProps } from 'react';

export const ErrorIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.707 13.293L13.293 14.707L10 11.414L6.707 14.707L5.293 13.293L8.586 10L5.293 6.707L6.707 5.293L10 8.586L13.293 5.293L14.707 6.707L11.414 10L14.707 13.293ZM10 0C4.486 0 0 4.486 0 10C0 15.514 4.486 20 10 20C15.514 20 20 15.514 20 10C20 4.486 15.514 0 10 0Z"
        fill="currentColor"
      />
    </svg>
  );
};
